
//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url +   Vue.prototype.$config.resources.attachment

const attachment = {
  create(payload :any,keyServies: string, keyValue: string,headers :any, token: boolean = true, config: any = {}) {
    let uri = url.replace("{0}", keyServies).replace("{1}", keyValue)
        return Vue.prototype.$httpService.post(uri, payload, headers, token, config)
  },
 
  partial_edit(id:string|number,payload:any ,keyServies: string, keyValue: string) {
    let uri = url.replace("{0}", keyServies).replace("{1}", keyValue)

    return Vue.prototype.$httpService.patch(uri + "/" + id ,payload)
  },
  find(id:string|number ,keyServies: string, keyValue: string) {
    let uri = url.replace("{0}", keyServies).replace("{1}", keyValue)
    return Vue.prototype.$httpService.get(uri + "/" + id)
  },
  delete(id:string|number ,keyServies: string, keyValue: string) {
  let uri = url.replace("{0}", keyServies).replace("{1}", keyValue)
    return Vue.prototype.$httpService.delete(uri + "/" + id)
  },
  list(params :any = {}) {
    return Vue.prototype.$httpService.get(url, params)
  }
}

export default attachment;

